var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_c('div',{staticClass:"container"},[_c('router-view'),_c('div',{staticClass:"backtop pointer",class:{ visible: _vm.scrollPosition > 800 },on:{"click":_vm.backtop}},[_vm._m(0),_vm._v(" TOP ")]),_c('footerView')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('i',{staticClass:"el-icon-arrow-up"})])
}]

export { render, staticRenderFns }